import { Component, OnInit } from '@angular/core';
import Utils from '../../../util';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';

@Component({
  template: ''
})
export class PlatformRedirectorComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router
    ) {
  }

  ngOnInit() {
    this.route.queryParams.pipe(take(1)).subscribe(param => {
      if (param['service'] === 'ado') {
        window.location.href = Utils.getAdoUrl();
      } else if (param['service'] === 'adm') {
        window.location.href = Utils.getAdmUrl();
      } else if (param['service'] === 'adf') {
        window.location.href = Utils.getAdfUrl();
      } else {
        this.router.navigateByUrl('/home');
      }
    });
  }
}
